import { useState, useEffect } from "react";

interface CountdownTime {
  days: number;
  isExpired: boolean;
}

export const useCountdown = (targetDate: Date): CountdownTime => {
  const [countdown, setCountdown] = useState<CountdownTime>(() => {
    return calculateTimeLeft(targetDate);
  });

  useEffect(() => {
    // Update every minute to keep it fresh
    const interval = setInterval(() => {
      setCountdown(calculateTimeLeft(targetDate));
    }, 60000); // 60000ms = 1 minute

    return () => clearInterval(interval);
  }, [targetDate]);

  return countdown;
};

const calculateTimeLeft = (targetDate: Date): CountdownTime => {
  const now = new Date().getTime();
  const target = targetDate.getTime();
  const difference = target - now;

  if (difference <= 0) {
    return {
      days: 0,
      isExpired: true
    };
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    isExpired: false
  };
};
